import { Link } from "react-router-dom";
import { saasDocMenu } from "../../fake-data/Saas-doc-menu";

const allMenus = saasDocMenu.flatMap((menu) => {
  if (menu.routerPath) return menu;
  return menu.dropDownItems;
});

function NavigationBtns() {
  const windowPath = window.location.pathname;
  const currentMenuIdx = allMenus.findIndex(
    (menu) => menu.routerPath === windowPath
  );

  if (currentMenuIdx === -1) return null;

  let currentMenus;
  if (currentMenuIdx === 0) {
    currentMenus = [null, allMenus[1]];
  } else if (currentMenuIdx === allMenus.length - 1) {
    currentMenus = [allMenus[allMenus.length - 2], null];
  } else {
    currentMenus = [allMenus[currentMenuIdx - 1], allMenus[currentMenuIdx + 1]];
  }

  return (
    <div className="center-page-container">
      {currentMenus.map(
        (menu, idx) =>
          menu && (
            <Link
              key={menu.routerPath}
              to={menu.routerPath}
              className={`btn  ${idx === 0 ? "previous" : "next"}`}
            >
              <p>{idx === 0 ? "Previous" : "Next"}</p>
              <p className="link"> {menu.name} </p>
            </Link>
          )
      )}
    </div>
  );
}

export default NavigationBtns;
